import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Table, Input, Checkbox, Button} from 'semantic-ui-react';
import {enterKeyCode, tabKeyCode} from '../../../../common/constants/keyCodes';
import {getTotalColumn, getTotalColumnPart, falsePrincipalPart, validateUnique} from '../../../utils';
import {Actions} from '../../../../common/actions';

const FormParts = (props) => {
  const {principalPart, id, fr, description, quantity, price,
    handleChange, handleAddItem, handleCheckBox, handleKeyDown, loading} = props;
  const validateBtn = description === '' || quantity <= 0;

  return (
    <Table.Row>
      <Table.Cell>
        <Checkbox
          disabled={loading}
          label='O.F.P'
          checked={principalPart}
          onChange={handleCheckBox}/>
      </Table.Cell>
      <Table.Cell>
        <Input
          disabled={loading}
          className="twc-works-input"
          placeholder='No. de parte'
          value={id}
          onKeyDown={handleKeyDown}
          onChange={(e, {value}) => handleChange('id', value)} />
      </Table.Cell>
      <Table.Cell>
        {fr}
      </Table.Cell>
      <Table.Cell>
        {description}
      </Table.Cell>
      <Table.Cell>
        <Input
          disabled={loading}
          className="twc-works-input"
          value={quantity}
          type="number"
          min="0"
          onChange={(e, {value}) => handleChange('quantity', value)}
        />
      </Table.Cell>
      <Table.Cell>
        $ {price ? price : 0}
      </Table.Cell>
      <Table.Cell> $ { quantity ? (+quantity * +price).toFixed(2) : 0}</Table.Cell>
      <Table.Cell>
        <Button
          disabled={validateBtn}
          onClick={() => handleAddItem()}
          size='mini'
          color="green">
            Agregar
        </Button>
      </Table.Cell>
    </Table.Row>
  );
};

const DisplayData = ({item, handleRemoveItem, idx, handleUpdatePrincipalPart, handleUpdateAmount, disabledBtns}) => {
  const {id, fr, quantity, price, principalPart, description} = item;

  return (
    <Table.Row>
      <Table.Cell>
        <Checkbox
          disabled={disabledBtns}
          onChange={(e, data) => handleUpdatePrincipalPart(e, data, item)}
          checked={principalPart === 'S'}
        />
      </Table.Cell>
      <Table.Cell>{id}</Table.Cell>
      <Table.Cell>{fr}</Table.Cell>
      <Table.Cell>{description}</Table.Cell>
      <Table.Cell>
        <Input
          className='twc-works-input'
          value={quantity}
          type='number'
          min='0'
          onChange={(e, {value}) => handleUpdateAmount('quantity', value, item)}
        />
      </Table.Cell>
      <Table.Cell>$ {price}</Table.Cell>
      <Table.Cell>$ {(+quantity * +price).toFixed(2)}</Table.Cell>
      <Table.Cell>
        <Button
          disabled={disabledBtns}
          onClick={() => handleRemoveItem(idx)}
          size='mini'
          color='red'
        >
          Eliminar
        </Button>
      </Table.Cell>
    </Table.Row>
  );
};

const initialState = {
  'id': '',
  'principalPart': false,
  'fr': '',
  'quantity': 0.0,
  'price': 0.0,
  'description': '',
  'searchPart': false,
};

class Parts extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ...initialState,
    };
  }

  handleAddItem = () => {
    const {handleChangeForm} = this.props;
    const {principalPart, id, fr, quantity, price, description} = this.state;
    const newParts = [...this.props.parts];
    const item = {
      id,
      fr,
      'quantity': +quantity,
      'price': +price,
      'total': +price * +quantity,
      'principalPart': principalPart ? 'S' : 'N',
      description,
    };

    if (validateUnique(newParts, 'id', id)) {
      const parts = principalPart ? falsePrincipalPart(newParts, 'principalPart') : newParts;
      parts.push(item);
      this.setState({
        ...initialState,
      }, () => {
        handleChangeForm('parts', parts);

        if (principalPart) {
          handleChangeForm('principalPart', id);
          handleChangeForm('principalPartDescription', description);
        }
      });
    } else {
      this.props.addMessageBoxError(`El item ${id} ya se encuentra en la lista`);
    }
  }

  handleRemoveItem = (id) => {
    const {handleChangeForm} = this.props;
    const parts = [...this.props.parts].filter((item, idx) => idx !== id);
    handleChangeForm('parts', parts);
  }

  componentDidUpdate() {
    const {part} = this.props;

    if (this.state.id === part.code && this.state.searchPart) {
      this.setState({
        'description': part.name,
        'fr': part.franchise,
        'price': part.pvpToyotaEcuador,
        'searchPart': false,
      });
    }
  }

  handleCheckBox = (event, data) => {
    this.setState({
      'principalPart': data.checked,
    });
  }

  handleChange = (field, value) => {
    this.setState({
      [field]: value,
      'description': field === 'id' ? '' : this.state.description,
    });
  }

  handleKeyDown = (e) => {
    const {id} = this.state;
    if (e.keyCode === enterKeyCode || e.keyCode === tabKeyCode) {
      if (id.length > 1) {
        this.props.getWarrantyPart(id);
        this.setState({'searchPart': true});
      }
      e.preventDefault();
    }
  }

  handleUpdatePrincipalPart = (event, data, selectItem) => {
    const {parts, handleChangeForm} = this.props;
    const updatePrincipalPart = parts.map((item) => {
      if (item.id === selectItem.id) {
        return {
          ...selectItem,
          'principalPart': data.checked ? 'S' : 'N',
        };
      }
      return {
        ...item,
        'principalPart': 'N',
      };
    });
    handleChangeForm('parts', updatePrincipalPart);
    handleChangeForm('principalPart', selectItem.id);
    handleChangeForm('principalPartDescription', selectItem.description);
  }

  handleUpdateAmount = (field, value, selectItem) => {
    const {parts, handleChangeForm} = this.props;
    const newParts = parts.map((item) => {
      if (item.id === selectItem.id) {
        return {
          ...selectItem,
          [field]: +value,
          'total': selectItem.price * +value,
        };
      }
      return item;
    });
    handleChangeForm('parts', newParts);
  };

  render() {
    const {loading, parts, disabledBtns} = this.props;

    return (
      <div>
        <div className='warranty-container-table'>
          <Table celled>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>O.F.P</Table.HeaderCell>
                <Table.HeaderCell>No. de parte</Table.HeaderCell>
                <Table.HeaderCell>Franquicia</Table.HeaderCell>
                <Table.HeaderCell>Descripción</Table.HeaderCell>
                <Table.HeaderCell>Cantidad</Table.HeaderCell>
                <Table.HeaderCell>V. Unitario</Table.HeaderCell>
                <Table.HeaderCell>Total</Table.HeaderCell>
                <Table.HeaderCell></Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {!disabledBtns && (
                <FormParts
                  handleChange={this.handleChange}
                  {...this.state}
                  handleAddItem={this.handleAddItem}
                  handleCheckBox={this.handleCheckBox}
                  handleKeyDown={this.handleKeyDown}
                  loading={loading}
                />
              )}
              {parts.map((part, idx) => (
                <DisplayData
                  disabledBtns={disabledBtns}
                  handleUpdatePrincipalPart={this.handleUpdatePrincipalPart}
                  handleUpdateAmount={this.handleUpdateAmount}
                  key={idx}
                  item={part}
                  idx={idx}
                  handleRemoveItem={this.handleRemoveItem}
                />
              ))}
              <Table.Row className='warranty-table-footer'>
                <Table.Cell />
                <Table.Cell />
                <Table.Cell />
                <Table.Cell>SUBTOTAL</Table.Cell>
                <Table.Cell>
                  {getTotalColumn(parts, 'quantity').toFixed(2)}{' '}
                </Table.Cell>
                <Table.Cell />
                <Table.Cell>
                  $ {getTotalColumnPart(parts, 'price', 'quantity').toFixed(2)}
                </Table.Cell>
                <Table.Cell />
              </Table.Row>
            </Table.Body>
          </Table>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'permissions': state.session.permissions,
    'loading': state.warrantiesCategories.loading,
    'part': state.warrantiesCategories.part,
  };
};

const {getWarrantyPart, addMessageBoxError} = Actions;

export default connect(mapStateToProps, {
  getWarrantyPart,
  addMessageBoxError,
})(Parts);

